import styled from 'styled-components';

export const CommonContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 1rem;
  color: var(--text);
  overflow-x: hidden; /* Prevent horizontal scroll */
  padding-top: ${props => props.hasTopBar ? '120px' : '1rem'}; /* Space for fixed top bar */
  padding-bottom: ${props => props.hasPanel ? '400px' : '100px'}; /* Dynamic space for sticky panel */
  transition: padding 0.3s ease;
  
  /* Centering logic moved from MainContent */
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`;

export const AdminContainer = styled(CommonContainer)`
  padding-bottom: 2rem;
  text-align: left;
`;

export const Title = styled.h1`
  text-align: center;
  margin-bottom: 2rem;
  color: var(--primary);
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr; /* Changed from 300px 1fr to just 1fr */
  gap: 2rem;
  text-align: left;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Section = styled.div`
  background: rgba(255, 255, 255, 0.05);
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  margin-bottom: 1.5rem;
`;

export const AdminSection = styled.div`
  background: rgba(255, 255, 255, 0.05);
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  margin-bottom: 1.5rem;
  max-width: 800px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
`;

export const SubTitle = styled.h2`
  margin-bottom: 1rem;
  font-size: 1.25rem;
  border-bottom: 2px solid var(--primary);
  padding-bottom: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Button = styled.button`
  background: ${props => props.active ? 'var(--primary)' : 'transparent'};
  color: ${props => props.active ? '#fff' : 'inherit'};
  border: 1px solid var(--primary);
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  width: 100%;
  margin-bottom: 0.5rem;
  text-align: left;
  transition: all 0.2s;

  &:hover {
    background: var(--primary);
    color: #fff;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const AdminButton = styled.button`
  background: var(--primary);
  color: white;
  border: none;
  padding: 0.75rem;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 1rem;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }

  &.danger {
    background: #e74c3c;
  }
`;

export const PersonItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  
  > div {
    display: flex;
    width: 100%;
    word-wrap: break-word;

    > div {
      text-align: left;
    }
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const Badge = styled.span`
  font-size: 0.75rem;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  background: ${props => {
    switch (props.type) {
      case 'ida': return '#3498db';
      case 'vuelta': return '#e74c3c';
      case 'ambas': return '#9b59b6';
      default: return '#95a5a6';
    }
  }};
  color: white !important;
  margin-right: 0.75rem;
  min-width: 60px;
  text-align: center !important;
  align-content: center;
  display: inline-block;
  white-space: nowrap;
`;

export const AddButton = styled.button`
  background: var(--success, #2ecc71);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.25rem 0.75rem;
  cursor: pointer;
  font-size: 0.85rem;
  
  &:disabled {
    background: #95a5a6;
    cursor: not-allowed;
  }
  
  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

export const RemoveButton = styled.button`
  background: var(--danger, #e74c3c);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  font-size: 0.75rem;
  margin-left: 0.5rem;
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  border-radius: 6px;
  border: 1px solid rgba(255,255,255,0.2);
  background: rgba(0,0,0,0.2);
  color: var(--text);
  margin-bottom: 1rem;
  
  &:focus {
    outline: none;
    border-color: var(--primary);
    background-color:  rgba(255,255,255,0.8);
  }

  /* Prevent zoom on mobile */
  font-size: 16px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  label {
    font-size: 0.9rem;
    font-weight: bold;
    color: var(--primary);
  }

  input, select {
    padding: 0.75rem;
    border-radius: 6px;
    border: 1px solid rgba(255,255,255,0.2);
    background: rgba(0,0,0,0.2);
    color: var(--text);
    font-size: 1rem;

    &:focus {
      outline: none;
      border-color: var(--primary);
      background: rgba(255,255,255,0.8);
      color: #333;
    }
  }
`;

export const Message = styled.div`
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 6px;
  background: ${props => props.error ? 'rgba(231, 76, 60, 0.2)' : 'rgba(46, 204, 113, 0.2)'};
  border: 1px solid ${props => props.error ? '#e74c3c' : '#2ecc71'};
  color: ${props => props.error ? '#e74c3c' : '#2ecc71'};
  text-align: center;
`;

export const TabContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
`;

export const Tab = styled.button`
  background: ${props => props.active ? 'var(--primary)' : 'transparent'};
  color: ${props => props.active ? 'white' : 'var(--text)'};
  border: 1px solid var(--primary);
  padding: 0.5rem 1rem;
  border-radius: 20px;
  cursor: pointer;
  
  &:hover {
    background: var(--primary);
    color: white;
  }
`;

export const CreateNavGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 0.5rem;
    
    // First child (Eventos) takes full width
    & > button:first-child {
      grid-column: 1 / -1;
    }
  }
`;

export const BusPassengersList = styled.div`
  margin-bottom: 1rem;
  
  /* Desktop: con scroll y altura máxima */
  @media (min-width: 769px) {
    max-height: 300px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch; /* Smooth scrolling */
  }
  
  /* Mobile: sin scroll, altura automática */
  @media (max-width: 768px) {
    max-height: none;
    overflow-y: visible;
  }
`;

export const SearchResultsList = styled.div`
  /* Desktop */
  @media (min-width: 769px) {
    max-height: 40vh;
    overflow-y: auto;
  }
  
  /* Mobile: altura dinámica según si tiene focus */
  @media (max-width: 768px) {
    ${props => props.searchFocused ? `
      flex: 1;
      max-height: none;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
    ` : `
      max-height: 40vh;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    `}
    transition: max-height 0.3s ease;
  }
`;

export const SearchSection = styled(Section)`
  /* En mobile con focus, se vuelve casi fullscreen */
  @media (max-width: 768px) {
    ${props => props.searchFocused && `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 999;
      margin: 0;
      border-radius: 0;
      max-width: 100%;
      height: 100vh;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      /* Ensure search input is not hidden behind Dynamic Island/Notch */
      padding-top: max(2rem, calc(env(safe-area-inset-top) + 1rem));
      padding-bottom: max(1.5rem, env(safe-area-inset-bottom));
    `}
  }
`;

export const UndoButton = styled.button`
  background: #f39c12;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  width: 100%;
  font-weight: bold;

  &:disabled {
    background: #7f8c8d;
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const LogItem = styled.div`
  font-size: 0.8rem;
  padding: 0.25rem 0;
  border-bottom: 1px solid rgba(255,255,255,0.05);
  opacity: 0.8;
  
  &:first-child {
    color: var(--primary);
    font-weight: bold;
    opacity: 1;
  }
`;

export const StickyTopBar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: var(--background-alt);
  border-bottom: 3px solid var(--primary);
  box-shadow: 0 2px 20px rgba(0,0,0,0.2);
  padding: 1rem 2rem;
  z-index: 1100;
  animation: slideDown 0.3s ease-out;

  @keyframes slideDown {
    from { transform: translateY(-100%); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }

  .bar-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .bus-info {
    flex: 1;
    background: var(--primary);
    color: white;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      opacity: 0.9;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    }

    .bus-name {
      font-weight: bold;
      font-size: 1.1rem;
    }

    .bus-stats {
      font-size: 0.9rem;
      opacity: 0.95;
    }
  }

  .history-button {
    background: var(--background);
    border: 2px solid var(--primary);
    color: var(--primary);
    padding: 0.5rem 1rem;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 600;
    transition: all 0.2s;
    white-space: nowrap;
    text-align: left;

    display: flex;
    justify-content: center;
    gap: 0.5rem;

    > span {
      align-content: center;
    }

    &:hover {
      background: var(--primary);
      color: white;
    }
  }
`;

export const StickyPanel = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: var(--background-alt);
  border-top: 2px solid var(--primary);
  box-shadow: 0 -4px 20px rgba(0,0,0,0.5);
  padding: 1.5rem 2rem;
  padding-bottom: max(1.5rem, env(safe-area-inset-bottom));
  z-index: 1000;
  animation: slideUp 0.3s ease-out;
  min-height: 200px;
  display: flex;
  flex-direction: column;

  @keyframes slideUp {
    from { transform: translateY(100%); }
    to { transform: translateY(0); }
  }

  .panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    h3 {
      color: var(--font);
      margin: 0;
    }
  }

  .close-button {
    background: rgba(255,255,255,0.2);
    border: 1px solid var(--font);
    color: var(--font);
    padding: 0.25rem 0.75rem;
    border-radius: 4px;
    font-size: 0.9rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.2s;

    &:hover { 
      background: rgba(255,255,255,0.3);
    }
  }

  .members-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 1rem;
    max-height: 300px; /* Limit height to show ~3-4 items */
    overflow-y: auto;  /* Enable vertical scrolling */
    padding-right: 0.5rem; /* Avoid scrollbar covering content */
    
    /* Smooth scrolling */
    -webkit-overflow-scrolling: touch;
  }

  .member-card {
    padding: 0.75rem;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 2px solid var(--primary);
  }

  .member-info {
    display: flex;
    
    span {
      color: var(--font);
      font-weight: bold;
      text-align: left;
    }
  }
`;

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.7);
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  .modal-content {
    background: var(--background-alt);
    border: 2px solid var(--primary);
    border-radius: 12px;
    padding: 2rem;
    max-width: 600px;
    width: 90%;
    max-height: 80vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
    box-shadow: 0 8px 40px rgba(0,0,0,0.5);
    animation: slideUp 0.3s ease-out;

    @keyframes slideUp {
      from { transform: translateY(50px); opacity: 0; }
      to { transform: translateY(0); opacity: 1; }
    }
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
    padding-bottom: 1rem;
    border-bottom: 2px solid var(--primary);

    h2 {
      margin: 0;
      color: var(--primary);
    }
  }

  .modal-close {
    background: transparent;
    border: 1px solid var(--primary);
    color: var(--primary);
    padding: 0.25rem 0.75rem;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1.2rem;
    transition: all 0.2s;

    &:hover {
      background: var(--primary);
      color: white;
    }
  }
`;

export const ConfirmDialog = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.7);
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  .dialog-content {
    background: var(--background-alt);
    border: 2px solid var(--primary);
    border-radius: 12px;
    padding: 2rem;
    max-width: 500px;
    width: 90%;
    box-shadow: 0 8px 40px rgba(0,0,0,0.5);
    animation: slideUp 0.3s ease-out;

    @keyframes slideUp {
      from { transform: translateY(50px); opacity: 0; }
      to { transform: translateY(0); opacity: 1; }
    }
  }

  .dialog-message {
    font-size: 1.1rem;
    margin-bottom: 1.5rem;
    color: var(--text);
    text-align: center;
  }

  .dialog-buttons {
    display: flex;
    gap: 1rem;
    justify-content: center;
  }

  .dialog-button {
    padding: 0.75rem 1.5rem;
    border-radius: 6px;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 600;
    transition: all 0.2s;
    border: none;

    &.confirm {
      background: var(--danger, #e74c3c);
      color: white;

      &:hover {
        opacity: 0.9;
        transform: translateY(-2px);
      }
    }

    &.cancel {
      background: transparent;
      border: 2px solid var(--primary);
      color: var(--primary);

      &:hover {
        background: var(--primary);
        color: white;
      }
    }
  }
`;
